import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState, type ReactNode } from 'react';
import { createQueryClient } from '@/config/reactQueryConfig';

interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  // CRITICAL DEBUG: Track QueryProvider re-renders
  const queryProviderRenderTimestamp = Date.now();
  
  const [queryClient] = useState(() => {
    const client = createQueryClient();
    
    // Expose query client globally for smart invalidation
    if (typeof window !== 'undefined') {
      window.__REACT_QUERY_CLIENT__ = client;
    }
    
    return client;
  });

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
